// 常量
import * as constants from 'js/constants/index'
// 工具方法
import * as utils from 'js/utils/index'

/**
 * 获取 viewer 需要的大图 url 并赋给img元素
 * @param {Object} imgs 图片元素数组
 * @return {Boolean} 成功 true; 失败 false。
 */
export function getImgUrl (options = {}) {
  options = Object.assign({}, options)

  if (!(argsInit(options) && argsValidate(options))) {
    return false
  }

  let {
    imgs,
  } = options

  for (let img of imgs) {
    img.setAttribute(constants.propertyName.viewer.hdUrl, img.getAttribute('src').replace(constants.imgRegExp.hdUrlFilter, ''))
  }

  return true
}

/**
 * 参数初始化
 */
function argsInit (options = {}) {
  let {
    imgs,
  } = options

  if (typeof imgs === 'string') {
    let obj = document.querySelectorAll(imgs)

    if (obj.length === 0) {
      utils.log.e(`[viewer][getImgUrl][argsInit] DOM element whose selector's ${wrapper} not found.`)
      return false
    }

    options.imgs = Array.from(obj)
  }

  return true
}

/**
 * 参数校验
 */
function argsValidate (options = {}) {
  let {
    imgs,
  } = options
  let from = '[viewer][getImgUrl][argsValidate]'

  if (imgs instanceof Array) {
    for (let img of imgs) {
      if (!(img instanceof Image)) {
        utils.log.e(`${from} img isn't an instance of Image.`)
        return false
      }
    }
  } else {
    utils.log.e(`${from} imgs isn't an instance of Array.`)
    return false
  }

  return true
}


// WEBPACK FOOTER //
// ./js/animation/viewer/getImgUrl.js